import { errorMessage } from "helpers/utils";
import { BU_METHOD_TYPE_SIGN } from "pages/GeneralInfo/BusinessUnitBK/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import BusinessUnitService from "services/BusinessUnitService";
import {
  activeBusinessUnitFail,
  activeBusinessUnitSuccess,
  createBusinessUnitFail,
  createBusinessUnitSuccess,
  detailBusinessUnitFail,
  detailBusinessUnitSuccess,
  listBusinessUnitFail,
  listBusinessUnitSuccess,
  updateBusinessUnitFail,
} from "store/actions";
import {
  BUSINESS_UNIT_CREATE,
  BUSINESS_UNIT_DELETE,
  BUSINESS_UNIT_DETAIL,
  BUSINESS_UNIT_LIST,
  BUSINESS_UNIT_UPDATE,
} from "./actionTypes";
import {
  deleteBusinessUnitFail,
  deleteBusinessUnitSuccess,
  updateBusinessUnitSuccess,
} from "./actions";
function* fetchListBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.listBusinessUnit, payload);
    yield put(listBusinessUnitSuccess(response));
  } catch (error) {
    yield put(listBusinessUnitFail(errorMessage(error)));
  }
}

function* handleSignMethod({
  typeSign,
  idTypeSign,
  businessUnitCode,
  typeSignValue,
}) {
  if (typeSign) {
    if (idTypeSign) {
      return yield call(BusinessUnitService.updateBUMethod, {
        buMethodId: idTypeSign,
        record_status: "O",
      });
    } else {
      return yield call(BusinessUnitService.addBUMethod, {
        business_unit_code: businessUnitCode,
        type_sign: typeSignValue,
      });
    }
  } else {
    if (idTypeSign) {
      return yield call(BusinessUnitService.updateBUMethod, {
        buMethodId: idTypeSign,
        record_status: "C",
      });
    }
  }
}

function* onUpdateBusinessUnit({ payload }) {
  try {
    const {
      decimal_place_foreign_currency,
      id_configurations,
      type_sign_hsm,
      type_sign_usb_token,
      id_type_sign_hsm,
      id_type_sign_usb_token,
    } = payload.data;
    const response = yield call(
      BusinessUnitService.updateBusinessUnit,
      payload
    );
    let responseConfig = null;
    const dataConfig = {
      type: 1,
      bu_code: response.code,
      data: {
        decimal_place: {
          foreign_currency: decimal_place_foreign_currency,
        },
      },
    };
    if (id_configurations) {
      responseConfig = yield call(
        BusinessUnitService.updateConfigInvoiceByBuCode,
        {
          configId: id_configurations,
          data: dataConfig,
        }
      );
    } else {
      responseConfig = yield call(
        BusinessUnitService.addConfigInvoiceByBuCode,
        {
          data: dataConfig,
        }
      );
    }
    //
    const responseSignHSM = yield handleSignMethod({
      typeSign: type_sign_hsm,
      idTypeSign: id_type_sign_hsm,
      businessUnitCode: response?.code,
      typeSignValue: BU_METHOD_TYPE_SIGN.TYPE_SIGN_HSM,
    });
    const responseSignUSBToken = yield handleSignMethod({
      typeSign: type_sign_usb_token,
      idTypeSign: id_type_sign_usb_token,
      businessUnitCode: response?.code,
      typeSignValue: BU_METHOD_TYPE_SIGN.TYPE_SIGN_USB_TOKEN,
    });
    yield put(updateBusinessUnitSuccess(response));
  } catch (error) {
    yield put(updateBusinessUnitFail(errorMessage(error)));
  }
}
function* onCreateBusinessUnit({ payload }) {
  try {
    const response = yield call(
      BusinessUnitService.createBusinessUnit,
      payload
    );
    yield put(createBusinessUnitSuccess(response));
  } catch (error) {
    yield put(createBusinessUnitFail(errorMessage(error)));
  }
}

function* onDetailBusinessUnit({ payload }) {
  try {
    const response = yield call(
      BusinessUnitService.detailBusinessUnit,
      payload
    );
    let configResponse = null;
    let configBuMethod = null;
    if (response) {
      // Get Config
      configResponse = yield call(
        BusinessUnitService.configInvoiceByBuCode,
        response.code
      );
      let decimal_place_foreign_currency = 3;
      let idConfigurations = null;
      if (configResponse?.items.length > 0) {
        const config = configResponse?.items[0];
        decimal_place_foreign_currency =
          config?.data.decimal_place?.foreign_currency;
        idConfigurations = config.id;
      }
      response["decimal_place_foreign_currency"] =
        decimal_place_foreign_currency;
      response["id_configurations"] = idConfigurations;
      // Get BU method
      configBuMethod = yield call(BusinessUnitService.getListBUMethodSign, {
        business_unit_code: response.code,
        shop_code: response.code,
      });
      if (configBuMethod?.items.length > 0) {
        const typeSignHSM = configBuMethod?.items?.find(
          i => i.type_sign === BU_METHOD_TYPE_SIGN.TYPE_SIGN_HSM
        );
        const typeSignUSBToken = configBuMethod?.items?.find(
          i => i.type_sign === BU_METHOD_TYPE_SIGN.TYPE_SIGN_USB_TOKEN
        );
        response["type_sign_hsm"] = typeSignHSM?.record_status === "O" ? 1 : 0;
        response["id_type_sign_hsm"] = typeSignHSM?.id;

        response["type_sign_usb_token"] =
          typeSignUSBToken?.record_status === "O" ? 1 : 0;
        response["id_type_sign_usb_token"] = typeSignUSBToken?.id;
      } else {
        response["type_sign_hsm"] = false;
        response["id_type_sign_hsm"] = null;

        response["type_sign_usb_token"] = false;
        response["id_type_sign_usb_token"] = null;
      }
    }
    yield put(detailBusinessUnitSuccess(response));
  } catch (error) {
    yield put(detailBusinessUnitFail(errorMessage(error)));
  }
}

function* onDeleteBusinessUnit({ payload }) {
  try {
    const response = yield call(
      BusinessUnitService.deleteBusinessUnit,
      payload
    );
    yield put(deleteBusinessUnitSuccess(response));
  } catch (error) {
    yield put(deleteBusinessUnitFail(errorMessage(error)));
  }
}

function* onActiveBusinessUnit({ payload }) {
  try {
    const response = yield call(
      BusinessUnitService.activeBusinessUnit,
      payload
    );
    yield put(activeBusinessUnitSuccess(response));
  } catch (error) {
    yield put(activeBusinessUnitFail(errorMessage(error)));
  }
}

function* userManagementSaga() {
  yield takeEvery(BUSINESS_UNIT_LIST, fetchListBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_CREATE, onCreateBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_DETAIL, onDetailBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_UPDATE, onUpdateBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_DELETE, onDeleteBusinessUnit);
}

export default userManagementSaga;
